import {
  notifyMeSeasonWinterEndDate,
  notifyMeSeasonWinterStartDate,
} from '@velasca/constants'
import { isDateDayMonthInRange } from './isDateDayMonthInRange'

/**
 * It should return a boolean representing if current date is inside the notifyMe winter range period.
 *
 */
export const isWinterNotifyMe = (): boolean => {
  return isDateDayMonthInRange({
    currentDate: new Date(),
    startDate: notifyMeSeasonWinterStartDate,
    endDate: notifyMeSeasonWinterEndDate,
  })
}
